import SwitchMapViewButton from './SwitchMapViewButton';

export default SwitchMapViewButton;
